(()=>{
  const preference=matchMedia('(prefers-reduced-motion: reduce)');
  const desktop=matchMedia('(min-width: 990px)');
  let controller,observer,frame=0,active=new Set(),targets=[];
  const bound=(n)=>Math.max(0,Math.min(1,n));
  function reset(){
    controller?.abort();observer?.disconnect();cancelAnimationFrame(frame);frame=0;active.clear();
    document.body.classList.remove('lgm-flow-enabled');
    targets.forEach(el=>{el.style.removeProperty('--flow-progress');el.style.removeProperty('--flow-hero');el.style.removeProperty('--flow-step');el.classList.remove('lgm-flow-step');el.getAnimations?.().forEach(a=>a.cancel());});
    targets=[];
  }
  function init(){
    reset();
    if(preference.matches||!('IntersectionObserver' in window))return;
    controller=new AbortController();
    const opts={signal:controller.signal};
    document.body.classList.add('lgm-flow-enabled');
    document.querySelectorAll('.lgm-story[data-flow-motion="true"]').forEach(section=>{
      if(section.classList.contains('lgm-story--steps')){
        if(section.querySelector('lgm-step-story'))return;
        section.querySelectorAll('.lgm-steps li').forEach(el=>{el.classList.add('lgm-flow-step');targets.push(el);});
      }else targets.push(section);
    });
    function update(){
      frame=0;if(document.hidden)return;
      const height=innerHeight;
      const positions=[...active].map(el=>[el,el.getBoundingClientRect()]);
      positions.forEach(([el,rect])=>{
        if(el.classList.contains('lgm-flow-step'))el.style.setProperty('--flow-step',bound((height*.84-rect.top)/(height*.45)).toFixed(4));
        else if(el.classList.contains('lgm-story--intro'))el.style.setProperty('--flow-hero',desktop.matches?bound(-rect.top/rect.height).toFixed(4):'0');
        else el.style.setProperty('--flow-progress',desktop.matches?bound((height*.8-rect.top)/(height*.8+rect.height*.4)).toFixed(4):'.5');
      });
    }
    const schedule=()=>{if(!frame&&!document.hidden)frame=requestAnimationFrame(update);};
    observer=new IntersectionObserver(entries=>{
      entries.forEach(({target,isIntersecting})=>{
        if(isIntersecting){
          active.add(target);
          if(target.classList.contains('lgm-flow-step')&&!target.dataset.flowSeen){
            target.dataset.flowSeen='true';
            if(target.animate)target.animate([{opacity:.6,translate:'0 12px'},{opacity:1,translate:'0 0'}],{duration:500,easing:'cubic-bezier(.16,1,.3,1)'});
          }
        }else active.delete(target);
      });schedule();
    },{rootMargin:'12% 0px',threshold:0});
    targets.forEach(el=>observer.observe(el));
    addEventListener('scroll',schedule,{...opts,passive:true});
    addEventListener('resize',schedule,opts);
    document.addEventListener('visibilitychange',schedule,opts);
    schedule();
  }
  preference.addEventListener('change',init);
  desktop.addEventListener('change',init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>queueMicrotask(init));
  addEventListener('pagehide',reset);
  addEventListener('pageshow',init);
  init();
})();
